import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, MyAxios } from '@services/SettingAxios';
import { FetchStoresByServiceAndDataWidgetType, FetchStoresByServiceType } from '@entities/Shop/module/types/storesByServiceSchema';
import { AxiosResponse } from 'axios';
import { ServiceWidget } from '@services/ServiceWidget';
import { ServiceShop } from '@services/ServiceShop';

export const fetchStoresByService = createAsyncThunk<
  FetchStoresByServiceAndDataWidgetType,
  { regionId: number; listFilter: number[]; isDataWidget?: boolean }
>('storesByService/fetchStoresByService', async ({ regionId, listFilter, isDataWidget }) => {
  try {
    const response: AxiosResponse<{ data: FetchStoresByServiceType; success: boolean }> = await MyAxios.post(
      `/api/shops/get-shops-v1?region=${regionId}`,
      { listFilter },
    );

    if (isDataWidget) {
      const stores = response?.data.data.shops;
      const storesIds = stores.map(shop => shop.id);
      const dataWidget = !!storesIds.length && (await ServiceWidget.getRecordShm(storesIds));
      ServiceShop.enrichmentDataWidgetShop(stores, dataWidget);
    }

    return response.data?.data;
  } catch (error) {
    return handleError(error);
  }
});
